import ActionButton from 'components/ActionButton';
import React, { useState } from 'react';
import { markAllRoutesAsPacked, processHomeBoxOrders, resetUnfulfilledQuantityForAllItems } from 'services';
import { showError, showSuccess } from 'utils';
import styles from './index.module.scss';
import PendingOrderDeliveryEmail from './PendingOrderDeliveryEmail';

const Actions = () => {
  const [loading, setLoading] = useState<string>('');

  const handleHomeBoxOrdersClick = async () => {
    setLoading('home_box');
    try {
      await processHomeBoxOrders();
      showSuccess('Home Box Order creation started successully');
    } catch (e) {
      showError(e);
    } finally {
      setLoading('');
    }
  };

  const handleMarkAsPackedClick = async () => {
    try {
      setLoading('route_pack');
      await markAllRoutesAsPacked();
      showSuccess('Marking all Routes as Packed Started');
    } catch (e) {
      showError(e);
    } finally {
      setLoading('');
    }
  };

  const handleUnfulfilledQuantityReset = async () => {
    try {
      setLoading('reset_unfulfilled');
      await resetUnfulfilledQuantityForAllItems();
      showSuccess('Resetting all items unfulfilled quantity started');
    } catch (e) {
      showError(e);
    } finally {
      setLoading('');
    }
  };


  return (
    <div>
      <div className={styles['header']}>
        <div className={styles['heading']}>Actions</div>
      </div>
      <div className={styles['container']}>
        <ActionButton
          text={'Process Home Box Orders'}
          active={true}
          isLoading={loading === 'home_box'}
          onClick={handleHomeBoxOrdersClick}
        />
        <PendingOrderDeliveryEmail />
        <ActionButton
          text={'Mark All Routes as Packed'}
          active={true}
          isLoading={loading === 'route_pack'}
          onClick={handleMarkAsPackedClick}
        />
        <ActionButton
          text={'Reset All Items Unfulfilled Quantity'}
          active={true}
          isLoading={loading === 'reset_unfulfilled'}
          onClick={handleUnfulfilledQuantityReset}
        />
      </div>
    </div>
  );
};

export default Actions;
